import './trending-searches.css';
